module.exports = __webpack_public_path__ + "static/img/qcxj-club.48df4d1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/qcxj-club.jpeg
// module id = 994
// module chunks = 0